import { showUserNotify, showErrorNotify } from "@/helpers/notify";

export default (adminURL, instance) => {
  return {
    getUsersData(payload) {
      return instance
        .post(adminURL + "user/all", payload)
        .catch((error) => showErrorNotify(error));
    },
    createUser(payload) {
      return instance
        .post(adminURL + "user/create", payload)
        .then(() => showUserNotify("success"))
        .catch((error) => {
          showErrorNotify(error);

          throw error;
        });
    },
    updateUser(id, payload) {
      return instance
        .put(adminURL + `user/${id}`, payload)
        .then(() => showUserNotify("success"))
        .catch((error) => {
          showErrorNotify(error);

          throw error;
        });
    },
    removeUser(id) {
      return instance
        .delete(adminURL + `user/${id}`)
        .then(() => showUserNotify("success"))
        .catch((error) => {
          showErrorNotify(error);

          throw error;
        });
    },
  };
};
